import React, { useState, useRef, useEffect } from "react";

export function DropdownMenu({ label, children }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={menuRef}>
      <button
        onClick={() => setOpen(!open)}
        // className="px-4 py-2 bg-gray-100 border rounded-md hover:bg-gray-200"
      >
        {label}
      </button>

      {open && (
        <div className="absolute right-0 z-[99999] mt-2 w-28 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5">
          <div className="">{children}</div>
        </div>
      )}
    </div>
  );
}

export function DropdownMenuItem({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full px-4 py-2 rounded-md text-left text-sm text-gray-700 hover:bg-[#E6DCFF]"
    >
      {children}
    </button>
  );
}